/*
 * @Description: 订单相关接口
 * @FilePath: \api\modules\order.js
 * @Author: 王逢超 wangfengchao@nextmar.com
 * @Date: 2022-06-21 11:41:24
 */

import { request } from '../request';

export default {
  // 支付页面获取运输方式及运费
  getFreight: (data) => request('/api/order/get_freight', 'post', data),
  // 支付页面获取优惠券下拉数组
  orderCoupon: (data) => request('/api/order/coupon', 'get', data),
  // 支付页面优惠计价
  orderPrice: (data) => request('/api/order/price', 'get', data),
  // 支付页面创建订单
  createOrder: (data) =>
    request(
      '/api/order/create',
      'post',
      {
        ...data,
        utm_info: window
          ? {
              pub_zl_utm_source:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_source || undefined
                  : undefined,
              pub_zl_utm_medium:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_medium || undefined
                  : undefined,
              pub_zl_utm_campaign:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_campaign || undefined
                  : undefined,
              pub_zl_referrer:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_referrer || undefined
                  : undefined,
              pub_zl_page:
                window.latestChannelAttribute.expires > Date.now() ||
                window.latestChannelAttribute.expires === -1
                  ? window.latestChannelAttribute.pub_zl_page || undefined
                  : undefined,
              pub_landing_page: window.latestChannelAttribute.pub_landing_page || undefined,
            }
          : {},
      },
      { errorMsg: false },
    ),
  // 订单各个状态数量
  statistics: (data) => request('/api/order/statistics', 'get', data),
  // 订单列表
  orderLists: (data) => request('/api/order/lists', 'get', data),
  // 物流单号查询
  ordertrack: (id) => request(`/api/order/track/${id}`, 'get'),
  // 物流单号查询，显示完整的头程、尾程、加工信息
  ordertrack_new: (id) => request(`/api/order/track_new/${id}`, 'get'),
  // 发表评论
  writeReview: (data) => request('/api/order/review', 'post', data, { successMsg: true }),
  // 修改收货地址
  modifyAddress: (data) => request('/api/order/modify_address', 'post', data),
  // 订单详情
  orderDetail: (id) => request(`/api/order/details/${id}`, 'get', {}),
  // 订单重新加购
  reorder: (data) => request('/api/order/reorder', 'post', data),
  // 获取前台模块的时间标记
  getTimeSign: (data) => request('/api/customer/get_time_sign', 'get', data),
  // 待支付订单重新加购并关闭订单
  orderAgainApi: (data) => request('/api/order/again', 'post', data),
  // 订单子单更新处方
  updateItemPresImage: (data) =>
    request('/api/order/update_order_item_prescriptions_image', 'post', data),
  // payment页面退出时送优惠券(条件：当前无优惠券可用且商品金额大于49，第二次退出（由接口判断）)
  paymentRetainCoupon: (data) =>
    request('/api/order/retain_coupon', 'post', data, { errorMsg: false }),
  // payment页挽留弹窗显示
  retainOrderPopupApi: (data) => request('/api/order/retain_order_popup', 'post', data),
  // 订单工单变更列表
  orderChangeList: (data) => request('/api/order/mj_workorder', 'get', data),
};
